import Footer from '../components/footer/Footer';
import Navbar from '../components/navbar/Navbar';
import RoomInside from '../components/room/RoomInside';

export default function RoomInPage() {
    return (
        <>
            <Navbar />
            <RoomInside />
            <Footer />
        </>
    );
}
